module.exports = __webpack_public_path__ + "static/media/report_typical.21f18f42.svg";